/**
 * ProtectedRoute – zaštita ruta koje zahtevaju prijavu
 *
 * Ako korisnik nije ulogovan (nema access_token i loginData), prikazuje ForbiddenPage
 * sa porukom i dugmetom za prijavu. Inače renderuje children.
 */
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthContext';
import ForbiddenPage from './errors/ForbiddenPage';
import LoadingSpinner from './LoadingSpinner';
import UserPreferencesService from '@/shared/services/UserPreferencesService';
import { isPlatformAdmin, isAdminRoleName, normalizePlatformRoles } from '@/shared/auth/obligationAuth';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, isLoading, login } = useAuth();
  const location = useLocation();

  const isAuthenticated = user &&
    user.access_token &&
    user.loginData &&
    user.loginData.profile;

  const hasAdminRole = isPlatformAdmin(user);
  const isAdminPath = requireAdmin || location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!isAuthenticated || !isAdminPath || !hasAdminRole) return;
    const preferences = UserPreferencesService.getPreferences();
    if (isAdminRoleName(preferences.selectedRole)) return;
    const adminRoles = normalizePlatformRoles(user).filter((r) => isAdminRoleName(r));
    UserPreferencesService.savePreferences({
      ...preferences,
      selectedRole: adminRoles[0] || 'ADMIN',
    });
  }, [isAuthenticated, isAdminPath, hasAdminRole, user]);

  // Čekaj dok se autentifikacija učitava
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <ForbiddenPage onLogin={login} />;
  }

  if (isAdminPath && !hasAdminRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
















